<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
}

html {
  font-size: 100%;
  -webkit-text-size-adjust: 100%
}

a,b,body,dd,div,dl,dt,footer,h1,h2,h3,h4,h5,h6,header,html,i,img,li,p,section,ul {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box
}

body,html {
  width: 100%;
  min-height: 100%;
  overflow-x: hidden
}

body {
  font-family: Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",PingFang SC,Heiti SC,SimHei,Helvetica Neue,Helvetica,Droid Sans Fallback,sans-self;
  line-height: 1.4;
  font-size: 14px;
  background-color: #fff;
  color: #353535;
  user-select:text
}

ul {
  list-style: none
}

a {
  text-decoration: none;
  -webkit-tap-highlight-color: transparent
}

a,img {
  -webkit-touch-callout: none
}

img {
  width: auto;
  max-width: 100%;
  vertical-align: middle;
  -webkit-user-select: none;
  font-size: 0
}

.clf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden
}

.clf {
  display: block;
  zoom:1}

.fl {
  float: left
}

.fr {
  float: right
}

.vc {
  top: 50%;
  -webkit-transform: translate3d(-50%,-50%,0);
  transform: translate3d(-50%,-50%,0)
}

.c,.vc {
  position: absolute;
  left: 50%
}

.c {
  -webkit-transform: translate3d(-50%,0,0);
  transform: translate3d(-50%,0,0)
}

.hide {
  display: none
}

.rel {
  position: relative
}

.abs {
  position: absolute
}

.ellipsis {
  white-space: nowrap
}

.ellipsis,.ellipsis-multi {
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden
}

.ellipsis-multi {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical
}



</style>



// WEBPACK FOOTER //
// src/App.vue